import React from "react";

import SrrRowBase from "./SrrRowBase";

const TOMonthOfControlCarFamilyRegion = ({ row, items, group }) => {
  let optionsTable = ["modelName"];

  const renderItem = Object.keys(row)
    .map((key) => {
      if (group["arrTO"].includes(key)) {
        let serviceCounts = row[key]?.servicesCount;
        let percents = 0;
        if (row[key]?.salesCount > 0 && serviceCounts > 0) {
          percents = (serviceCounts / row[key]?.salesCount) * 100;
        }
        return [row[key]?.salesCount, serviceCounts, percents.toFixed(2)];
      }
    })
    .filter((value) => value !== undefined);

  return (
    <SrrRowBase
      leadingCells={optionsTable.map((el) =>
        el === "modelName" ? row["model"]?.name : el
      )}
      cells={renderItem}
    />
  );
};

export default TOMonthOfControlCarFamilyRegion;
